module.exports = __webpack_public_path__ + "img/banner8.29d3595e.png";